import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  checkUser: any;
  loading: boolean;
  passwordLoader: boolean;
  userData: any;
  isInitialLogin: boolean;
  routesHistory: any;
  newDashboardLoader: boolean;
  userAlreadyLogged:boolean
}

const initialState: InitialState = {
  checkUser: null,
  loading: false,
  passwordLoader: false,
  userData: null,
  isInitialLogin: false,
  routesHistory: [],
  newDashboardLoader: false,
  userAlreadyLogged:false
};

const authSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUserData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      userData: action.payload,
      loading: false,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: action.payload,
      }
    },
    setInitialLogin: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      isInitialLogin: action.payload,
    }),
    setRouteHistory: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      routesHistory: action.payload,
    }),
    setNewDashboardLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      newDashboardLoader: action.payload,
    }),
    setPasswordLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      passwordLoader: action.payload,
    }),
    setUserAlreadyLogged: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      userAlreadyLogged: action.payload,
    }),
  },
});

export const { setLoader,setPasswordLoader, setUserData, setInitialLogin, setRouteHistory, setNewDashboardLoader, setUserAlreadyLogged } = authSlice.actions;

export default authSlice.reducer;
